module.exports = __webpack_public_path__ + "static/media/aa-shop-50.9ff31c59.png";